module.exports = __webpack_public_path__ + "img/qoosquarefulllogo.01a6edf0.png";